import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them)

const resources = {
  en: {
    translation: {
      "Hello": "Hello",
      "Customer Information": "Customer Information",
      "Shipping Address": "Shipping Address",
      "First Name": "First Name",
      "Last Name": "Last Name",
      "Company": "Company",
      "Address": "Address",
      "Delivery Instructions": "Delivery Instruction",
      "Apt, suite, etc. (optional)": "Apt, suite, etc. (optional)",
      "City": "City",
      "Province": "Province",
      "Postal Code": "Postal Code",
      "Country": "Country",
      "Phone Number": "Phone Number",
      "Save this information for next time": "Save this information for next time",
      "Shipping": "Shipping",
      "Payment": "Payment",
      "ADD PROMO CODE": "ADD PROMO CODE",
      "Total Discount": "Total Discount",
      "Next": "Next",
      "Confirm": "Confirm",
      "Back": "Back",
      "Delivery": "Delivery",
      "Pickup": "Pickup",
      "Choose Time": "Choose Time",
      "Choose Store": "Choose Store",
      "Choose": "Choose",
      "Select time window": "Select time window",
      "TODAY": "TODAY",
      "Previous week": "Previous week",
      "Next week": "Next week",
      "Payment method": "Payment method",
      "All transactions are secure and encrypted. Credit card information is never stored.": "All transactions are secure and encrypted. Credit card information is never stored.",
      "Billing Address": "Billing Address",
      "Same as shipping address": "Same as shipping address",
      "Use a different billing address": "Use a different billing address",
      "Thank you": "Thank you",
      "Your order is confirmed": "Your order is confirmed",
      "We've accepted your order, and we're getting it ready. A confirmation email has been sent to": "We've accepted your order, and we're getting it ready. A confirmation email has been sent to",
      "Date": "Date",
      "Time": "Time",
      "Shipping Fee": "Shipping Fee",
      "Shipping method": "Shipping method",
      "Need help?": "Need help?",
      "Contact us": "Contact us",
      "Continue shopping": "Continue shopping",
      "Save card for furture purchases?": "Save card for furture purchases?",
      "Yes": "Yes",
      "No": "No",
      "Add delivery instructions": "Add delivery instructions",
      "Delivery Instructions": "Delivery Instructions",
      "Delivery Time": "Delivery Time",
      'Sorry no delivery options found, you can still select a pickup location': 'Sorry no delivery options found, you can still select a pickup location',
      "Please fill out the following information": "Please fill out the following information",
      "Order Summary": "Order Summary",
      "Choose how you want to get your order": "Choose how you want to get your order",
      "Pickup Instructions": "Pickup Instructions",
      "Apply": "Apply",
      "Please make sure billing address information is correctly filled out": "Please make sure billing address information is correctly filled out",
      "Close": "Close",
      "Field is required": "Field is required",
      "Last minute deals": "Last minute deals",
      "Cart": "Cart",
      "Customer": "Customer",
      "Edit cart": "Edit cart",
      "Discount code": "Discount code",
      "Subtotal": "Subtotal",
      "Tax": "Tax",
      "Total": "Total",
      "Continue to shipping": "Continue to shipping",
      "Privacy policy": "Privacy policy",
      "Refund policy": "Refund policy",
      "Terms of Service": "Terms of Service",
      "Schedule": "Schedule",
      "Choose Pickup Time": "Choose Pickup Time",
      "Choose Delivery Time": "Choose Delivery Time",
      "Add pickup instructions": "Add pickup instructions",
      "Pickup time": "Pickup time",
      "Delivery time": "Delivery time",
      "Continue to payment": "Continue to payment",
      "Store": "Store",
      "Update shipping address": "Update shipping address",
      "Update schedule": "Update schedule",
      "MON": "MON",
      "TUE": "TUE",
      "WED": "WED",
      "THU": "THU",
      "FRI": "FRI",
      "SAT": "SAT",
      "SUN": "SUN",
      "Monday": "Monday",
      "Tuesday": "Tuesday",
      "Wednesday": "Wednesday",
      "Thursday": "Thursday",
      "Friday": "Friday",
      "Saturday": "Saturday",
      "Sunday": "Sunday",
      "January": "January",
      "February": "February",
      "March": "March",
      "April": "April",
      "May": "May",
      "June": "June",
      "July": "July",
      "August": "August",
      "September": "September",
      "October": "October",
      "November": "November",
      "December": "December",
      "Delivery instructions or delivery contact info": "Delivery instructions or delivery contact info",
      "Eg. name and/or phone number of person who will pickup the order": "Eg. name and/or phone number of person who will pickup the order",
      "Subscribe for promotions": "Subscribe for promotions",
      "Should arrive": "Should arrive",
      "Change schedule": "Change schedule",
      "available": "available",
      "Bottle Deposit": "Bottle Deposit",
      "Change": "Change",
      "Save": "Save",
      "between": "between",
      "Please provide a valid email address": "Please provide a valid email address",
      "You can check what availabilities for delivery or pickup are available before you place your order": "You can check what availabilities for delivery or pickup are available before you place your order",
      "The amount corresponds to the total amount of your order plus 10%. The amount may vary according to the actual weight of the products (meat, fruit/vegetables, etc.) and according to the missing items. Once your order is assembled and the transaction completed, only the actual amount of the order will be charged to your card. The amount will be adjusted within 12-48 hours from the moment you received the email of your receipt.": "The amount corresponds to the total amount of your order plus 10%. The amount may vary according to the actual weight of the products (meat, fruit/vegetables, etc.) and according to the missing items. Once your order is assembled and the transaction completed, only the actual amount of the order will be charged to your card. The amount will be adjusted within 12-48 hours from the moment you received the email of your receipt.",
      //
      "The amount corresponds to the ": "The amount corresponds to the ",
      "total amount of your order plus 10%. ": "total amount of your order plus 10%. ",
      "The amount may vary according to the actual weight of the products (meat, fruit/vegetables, etc.) and according to the missing items.": "The amount may vary according to the actual weight of the products (meat, fruit/vegetables, etc.) and according to the missing items.",
      "Once your order is assembled and the transaction completed, only the actual amount of the order will be charged to your card. The amount will be adjusted within 12-48 hours from the moment you received the email of your receipt.": "Once your order is assembled and the transaction completed, only the actual amount of the order will be charged to your card. The amount will be adjusted within 12-48 hours from the moment you received the email of your receipt."

    }
  },
  fr: {
    translation: {
      "Hello": "Bonjour",
      "Customer Information": "Informations client",
      "Shipping Address": "Adresse de livraison",
      "First Name": "Prénom",
      "Last Name": "Nom de famille",
      "Company": "Entreprise",
      "Address": "Adresse",
      "Delivery Instructions": "Instruction de livraison",
      "Apt, suite, etc. (optional)": "Apt, suite, etc. (optional)",
      "City": "Ville",
      "Province": "Province",
      "Postal Code": "Code Postal",
      "Country": "Pays",
      "Phone Number": "Numéro de téléphone",
      "Save this information for next time": "Enregistrez ces informations pour la prochaine fois",
      "Shipping": "Livraison",
      "Payment": "Paiement",
      "ADD PROMO CODE": "AJOUTER UN CODE PROMO",
      "Total Discount": "Remise totale",
      "Next": "Suivant",
      "Confirm": "Confirmer",
      "Back": "Retour",
      "Delivery": "Livraison",
      "Pickup": "Ramassage",
      "Choose Time": "Choisissez l'heure",
      "Choose Store": "Choisissez le magasin",
      "Choose": "Choisissez",
      "Select time window": "Choisissez l'heure",
      "TODAY": "Aujourd'hui",
      "Previous week": "Semaine précédente",
      "Next week": "Prochaine semaine",
      "Payment method": "Mode de paiement",
      "All transactions are secure and encrypted. Credit card information is never stored.": "Toutes les transactions sont sécurisées et cryptées. Les informations de carte de crédit ne sont jamais stockées.",
      "Billing Address": "Adresse de facturation",
      "Same as shipping address": "Identique à l'adresse de livraison",
      "Use a different billing address": "Utilisez une adresse de facturation différente",
      "Thank you": "Merci",
      "Your order is confirmed": "Votre commande est confirmée",
      "We've accepted your order, and we're getting it ready. A confirmation email has been sent to": "Nous avons accepté votre commande et nous la préparons. Un e-mail de confirmation a été envoyé à",
      "Date": "Daté",
      "Time": "Temps",
      "Shipping Fee": "Frais de livraison",
      "Shipping method": "Méthode de livraison",
      "Need help?": "Besoin d'aide?",
      "Contact us": "Nous contacter",
      "Continue shopping": "Continuer vos achats",
      "Save card for furture purchases?": "Enregistrer la carte pour les achats futurs?",
      "Yes": "Oui",
      "No": "Non",
      "Add delivery instructions": "Ajouter des instructions de livraison",
      "Delivery Instructions": "Instructions de livraison",
      "Delivery time": "Heure de livraison",
      "Sorry no delivery options found, you can still select a pickup location": "Désolé, aucune option de livraison trouvée, vous pouvez toujours sélectionner un lieu de ramassage",
      "Please fill out the following information": "Veuillez remplir les informations suivantes",
      "Order Summary": "Récapitulatif de la commande",
      "Choose how you want to get your order": "Choisissez comment vous souhaitez recevoir votre commande",
      "Pickup Instructions": "Instructions de ramassage",
      "Apply": "Appliquer",
      "Please make sure billing address information is correctly filled out": "Veuillez vous assurer que les informations relatives à l'adresse de facturation sont correctement remplies",
      "Close": "Fermer",
      "Field is required": "Le champ est requis",
      "Last minute deals": "Offres de dernière minute",
      "Cart": "Panier",
      "Customer": "Client",
      "Edit cart": "Modifier le panier",
      "Discount code": "Code de réduction",
      "Subtotal": "Sous-total",
      "Tax": "Taxe",
      "Total": "Total",
      "Continue to shipping": "Continuer à l'expédition",
      "Privacy policy": "Politique de confidentialité",
      "Refund policy": "Politique de remboursement",
      "Terms of Service": "Conditions d'utilisation",
      "Schedule": "Calendrier",
      "Choose Pickup Time": "Choisir l'heure de ramassage",
      "Choose Delivery Time": "Choisir l'heure de livraison",
      "Add pickup instructions": "Ajouter des instructions de ramassage",
      "Pickup time": "Heure de prise en charge",
      "Delivery time": "Délai de livraison",
      "Continue to payment": "Continuer au paiement",
      "Store": "Magasin",
      "Update shipping address": "Mettre à jour l'adresse de livraison",
      "Update schedule": "Calendrier de mise à jour",
      "MON": "LUN",
      "TUE": "MAR",
      "WED": "MER",
      "THU": "JEU",
      "FRI": "VEN",
      "SAT": "SAM",
      "SUN": "DIM",
      "Monday": "Lundi",
      "Tuesday": "Mardi",
      "Wednesday": "Mercredi",
      "Thursday": "Jeudi",
      "Friday": "Vendredi",
      "Saturday": "Samedi",
      "Sunday": "Dimanche",
      "January": "Janvier",
      "February": "Février",
      "March": "Mars",
      "April": "Avril",
      "May": "Mai",
      "June": "Juin",
      "July": "Juillet",
      "August": "Août",
      "September": "Septembre",
      "October": "Octobre",
      "November": "Novembre",
      "December": "Décembre",
      "Delivery instructions or delivery contact info": "Instructions de livraison ou coordonnées de livraison",
      "Eg. name and/or phone number of person who will pickup the order": "Par exemple, le nom et/ou le numéro de téléphone de la personne qui récupérera la commande",
      "Subscribe for promotions": "Abonnez-vous aux promotions",
      "Should arrive": "Devrait arriver",
      "Change schedule": "Modifier l'horaire",
      "available": "disponible",
      "Bottle Deposit": "Dépôt de Bouteilles",
      "Change": "Modifier",
      "Save": "Enregistrer",
      "between": "entre",
      "Please provide a valid email address": "Veuillez fournir une adresse email valide",
      "You can check what availabilities for delivery or pickup are available before you place your order": "Vous pouvez vérifier quelles sont les disponibilités pour la livraison ou le pickup disponibles avant de passer votre commande",
      "The amount corresponds to the total amount of your order plus 10%. The amount may vary according to the actual weight of the products (meat, fruit/vegetables, etc.) and according to the missing items. Once your order is assembled and the transaction completed, only the actual amount of the order will be charged to your card. The amount will be adjusted within 12-48 hours from the moment you received the email of your receipt.": "Le montant correspond au montant total de votre commande plus 10%. Le montant peut varier selon le poids réel des produits (viande, fruits/légumes, etc.) et selon les articles manquants. Une fois la commande assemblée et la transaction complétée, seul le montant réel de la commande sera prélevé sur votre carte. Le montant sera ajusté dans les 12 à 48 heures à partir du moment où vous recevrez votre reçu par courriel.",
      //
      "The amount corresponds to the ": "Le montant correspond au ",
      "total amount of your order plus 10%. ": "montant total de votre commande plus 10%. ",
      "The amount may vary according to the actual weight of the products (meat, fruit/vegetables, etc.) and according to the missing items.": "Le montant peut varier selon le poids réel des produits (viande, fruits/légumes, etc.) et selon les articles manquants.",
      "Once your order is assembled and the transaction completed, only the actual amount of the order will be charged to your card. The amount will be adjusted within 12-48 hours from the moment you received the email of your receipt.": "Une fois la commande assemblée et la transaction complétée, seul le montant réel de la commande sera prélevé sur votre carte. Le montant sera ajusté dans les 12 à 48 heures à partir du moment où vous recevrez votre reçu par courriel."
    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;